/**
 * The stored file a rendered image URL was derived from, e.g.
 * `/images/s1/project/alpine-house/Kitchen.jpeg/<imgproxy-payload>` →
 * `project/alpine-house/kitchen.jpeg`.
 *
 * This is the join key between the ImageLabel search index and the page
 * builder. The two hold separate LibraryImage rows for the same photo — the
 * index's ids are absent from the module tree entirely — but both render from
 * the same stored file, so the path matches where the ids never do.
 */
export const imageSourceFile = (imageUrl: string): string => {
    const match = imageUrl.match(
        /\/images\/[^/]+\/(.+?\.(?:jpe?g|png|webp|avif|gif))(?:\/|$)/i,
    );
    return match?.[1]?.toLowerCase() ?? '';
};
